import { Avatar } from '@/components/avatar';
import { Popover } from '@flintmint/web-shared/components/popover';

import { useSafeLogout } from '@/hooks/use-safe-logout';

import styles from './account-menu.module.scss';

export const AccountMenu = () => {
  const { logout } = useSafeLogout();

  const accountMenu = [
    {
      icon: 'user',
      disabled: true,
      name: 'User Profile',
      rightNode: <span className={styles.comingSoon}>Coming soon</span>,
    },
    {
      type: 'divider',
    },
    {
      danger: true,
      name: 'Log Out',
      icon: 'logout-01',
      onClick: logout,
    },
  ];

  return (
    <Popover overflowPadding={10} offset={[0, 10]} menu={accountMenu} placement="bottom">
      <Avatar />
    </Popover>
  );
};
